import React, { useContext } from "react";
import TabContext from "../TabContext";
import PanelContainer from "./Panel.styles";
import { defaultProps } from "./Props";
const Panel = ({ tabGroup, className, children }) => {
  const { activeTab } = useContext(TabContext);
  const isActive = tabGroup === activeTab;
  const classes = ["tab-panel", className].filter(Boolean).join(" ");
  return isActive ? /* @__PURE__ */ React.createElement(PanelContainer, {
    className: classes,
    role: "tabpanel",
    hidden: !isActive,
    "aria-controls": tabGroup,
    "aria-hidden": !isActive,
    id: tabGroup
  }, children) : null;
};
Panel.defaultProps = defaultProps;
export default Panel;
